import React from "react"
import "./Logo.sass"
import ailosLogo from "../../../assets/images/Logo.svg"

const Logo = () => (
    <img src={ailosLogo} alt="logo ailos" className="d-inline-block align-top" />
)

export default Logo